// @flow
import React, { Children, type Node } from 'react';

import { ICONS } from 'Components/utils/icon/icons';

import { Icon, type IconName } from 'Components/frameworks/icon/Icon.jsx';

type Props = {
  children: Node,
  iconLeft?: IconName,
  id?: string,
  onClear?: (SyntheticEvent<>) => void,
};

export function CriteriaControl(props: Props) {
  const { children, iconLeft, onClear, id } = props;

  if (!Children.count(children)) return null;

  return (
    <div className="inline-block rtl:mr-3 mb-3">
      <div
        className="border-1 rounded-sm flex outline-custom px-3 relative rounded-tiny transition-colors bg-white border-gray-medium text-gray-darker"
        style={{ height: 41 }}
      >
        {!!iconLeft && (
          <div className="flex items-center justify-center rtl:pr-3">
            <Icon name={iconLeft} width="0.875rem" />
          </div>
        )}
        <div className="flex relative">
          <span className="flex items-center justify-center rtl:pr-3 font-sans text-base leading-4 capitalize">
            {children}
          </span>
          <button
            className="reset-button leading-none rtl:pl-3 transition-color text-gray-darker"
            data-testid={id}
            onClick={onClear}
            type="button"
          >
            <Icon name={ICONS.CROSS} width="0.625rem" />
          </button>
        </div>
      </div>
    </div>
  );
}
